import { prodOrDevCdnParam } from '@utils/isEnv'

export const subscriberIcon = `https://mandrake-app.b-cdn.net/${prodOrDevCdnParam()}/application/icons/subscribed-purple.svg`
